import VerifiedBadge from './VerifiedBadge.component';

export default VerifiedBadge;